<i18n>
{
  "fr": {
    "workDescription": "Description de l'ouvrage",
    "typeOfWork": "Type :",
    "regulation": "Régulation :",
    "number": "Nombre :",
    "activeSurfaceWork": "Surface active raccordée à l'ouvrage :",
    "surface": "Surface raccordée à l'ouvrage :",
    "problemList": "Liste des problèmes",
    "accessibilityProblem": "Problème d'accessibilité :",
    "commentAccessibilityProblem": "Commentaires :",
    "operationProblem": "Problème de fonctionnement :",
    "commentOperationProblem": "Commentaires :",
    "sizingProblem": "Problème de dimensionnement :",
    "commentSizingProblem": "Commentaires :",
    "stateOfRetentionStructure": "Problème état des ouvrages de rétention :",
    "commentstateOfRetentionStructure": "Commentaires :",
    "missingDocuments": "Documents manquants",
    "commentMissingDocuments": "Commentaires :",
    "maintenanceProblem": "Problème d'entretien :",
    "commentMaintenanceProblem": "Commentaires :",
    "trapdoor": "Trappes",
    "numberTrapdoor": "Nombre trappes :",
    "stateOfTrapdoor": "Etat :",
    "stick": "Cannes",
    "stateOfStick": "Etat :",
    "scaleToApron": "Echelons jusqu'au radier",
    "stateOfScaleToApron": "Etat :",
    "totalVolume": "Volume total (m3)",
    "overflow": "Surverses",
    "overflowHeight": "Hauteur (m) :",
    "continuousWater": "Eau permanente",
    "continuousWaterHeight": "Hauteur (m) :",
    "warehouse": "Dépôt",
    "warehouseHight": "Hauteur (m) :",
    "presenceWasteWater": "Présence EU",
    "presenceHydrocarbon": "Présence hydrocarbure",
    "performedDescent": "Descente effectuée",
    "numberArrival": "Nombre d'arrivées :",
    "observation": "Observations :",
    "workDetail": "Détails de l'ouvrage",
    "controlOfWork": "Régulation :",
    "regulationModel": "Marque / Modèle :",
    "regulationLocation": "Emplacement :",
    "regulationNumber": "Nombre :",
    "regulationDischargeHeight": "Hauteur Refoulement (m) :",
    "regulationRope": "Elingue",
    "regulationDiameter": "Diamètre :",
    "regulationSluiceGate": "Vanne",
    "regulationOverflow": "Surverse",
    "regulationHeight": "Hauteur :",
    "regulationEvacuationEquip": "Evacuations toutes équipées",
    "regulationOperation": "Fonctionnement",
    "evacuationMaintenanceRetention": "Entretien 'Rétention' :",
    "evacuationMaintenanceControl": "Entretien 'Régulation' :",
    "notebookMaintenance": "Carnet d'entretien SEVESC :",
    "observationRegulation": "Observations :",
    "debit": "Débit de fuite constaté pour cet ouvrage (L/s) : ",
    "volume": "Volume constaté pour cet ouvrage (m³) : ",
    "debitPrescrit":"Débit de fuite prescrit pour cet ouvrage (L/s) : ",
    "volumePrescrit":"Volume prescrit pour cet ouvrage (m³) : "
  }
}
</i18n>
<template>
  <div>
    <div v-for="id in worksCount()" :key="id">
      <div class="panel panel-info text-left" v-if="isEnabledWork(id)">
        <div class="panel-heading">
          Bilan de la visite par ouvrage n° {{ id }} -
          {{ getTypeOfWork(getFrozenControlPropertyWorkAttribute(id, 'typeOfWork')) }}
        </div>
        <div class="panel-body">
          <Content title>
            <span slot="main-text-1">
              <h4>{{ $t('workDescription') }}</h4>
              <hr />
              <p class="text">
                {{ $t('typeOfWork') }}
                <span >{{ getTypeOfWork(getFrozenControlPropertyWorkAttribute(id, 'typeOfWork')) }}</span>
              </p>
              <p class="text">
                {{ $t('regulation') }}
                <span>{{ getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) }}</span>
              </p>
              <p class="text">
                {{ $t('number') }}
                <span v-if="! [null, ''].includes(getFrozenControlPropertyWorkAttribute(id, 'number'))">{{
                  `${new Intl.NumberFormat().format(getFrozenControlPropertyWorkAttribute(id, 'number'))}`
                }}</span>
              </p>
              <p class="text">
                {{ $t('surface') }}
                <span v-if="! [null, ''].includes(getFrozenControlPropertyWorkAttribute(id, 'surface'))">{{
                  `${new Intl.NumberFormat().format(getFrozenControlPropertyWorkAttribute(id, 'surface'))}`
                }}</span>
              </p>
              <p class="text">
                {{ $t('activeSurfaceWork') }}
                <span v-if="! [null, ''].includes(getFrozenControlPropertyWorkAttribute(id, 'activeSurface'))">{{
                  `${new Intl.NumberFormat().format(getFrozenControlPropertyWorkAttribute(id, 'activeSurface'))}`
                }}</span>
              </p>
              <p class="text">
                {{ $t('debitPrescrit') }}
                <span v-if="! [null, ''].includes(getFrozenControlPropertyWorkAttribute(id, 'debit'))">{{
                  `${new Intl.NumberFormat().format(getFrozenControlPropertyWorkAttribute(id, 'debit'))}`
                }}</span>
              </p>
              <p class="text">
                {{ $t('debit') }}
                <span>{{ form['work' + id + '_debitNotice'] }}</span>
              </p>
              <p class="text">
                {{ $t('volumePrescrit') }}
                <span v-if="! [null, ''].includes(getFrozenControlPropertyWorkAttribute(id, 'volume'))">{{
                  `${new Intl.NumberFormat().format(getFrozenControlPropertyWorkAttribute(id, 'volume'))}`
                }}</span>
              </p>
              <p class="text">
                {{ $t('volume') }}
                <span v-if="! [null, ''].includes(form['work' + id + '_volumeNotice'])">{{ form['work' + id + '_volumeNotice'] }}</span>
              </p>
              <h4>{{ $t('problemList') }}</h4>
              <hr />
              <p class="text">
                {{ $t('accessibilityProblem') }}
                <span>{{ getValueOf(form['work' + id + '_accessibilityProblem']) }}</span>
              </p>
              <p class="text">
                {{ $t('commentAccessibilityProblem') }}
                <span>{{ form['work' + id + '_commentAccessibilityProblem'] }}</span>
              </p>
              <p class="text">
                {{ $t('operationProblem') }}
                <span>{{ getValueOf(form['work' + id + '_operationProblem']) }}</span>
              </p>
              <p class="text">
                {{ $t('commentOperationProblem') }}
                <span>{{ form['work' + id + '_commentOperationProblem'] }}</span>
              </p>
              <template v-if="typeForm === typeVpt()">
                <p class="text">
                  {{ $t('sizingProblem') }}
                  <span>{{ getValueOf(form['work' + id + '_sizingProblem']) }}</span>
                </p>
                <p class="text">
                  {{ $t('commentSizingProblem') }}
                  <span>{{ form['work' + id + '_commentSizingProblem'] }}</span>
                </p>
                <p class="text">
                  {{ $t('stateOfRetentionStructure') }}
                  <span>{{ getValueOf(form['work' + id + '_stateOfRetentionStructure']) }}</span>
                </p>
                <p class="text">
                  {{ $t('commentstateOfRetentionStructure') }}
                  <span>{{ form['work' + id + '_commentstateOfRetentionStructure'] }}</span>
                </p>
                <p class="text">
                  <template v-if="form['work' + id + '_missingDocuments'] == 1">
                    <v-icon name="check" />
                  </template>
                  <template v-else>
                    <v-icon name="times" class="nok" />
                  </template>
                  {{ $t('missingDocuments') }}
                </p>
                <p class="text">
                  {{ $t('commentMissingDocuments') }}
                  <span>{{ form['work' + id + '_commentMissingDocuments'] }}</span>
                </p>
              </template>
              <template v-if="typeForm === typeVe()">
                <p class="text">
                  {{ $t('maintenanceProblem') }}
                  <span>{{ getValueOf(form['work' + id + '_maintenanceProblem']) }}</span>
                </p>
                <p class="text">
                  {{ $t('commentMaintenanceProblem') }}
                  <span>{{ form['work' + id + '_commentMaintenanceProblem'] }}</span>
                </p>
              </template>
            </span>
            <span slot="main-text-2">
              <h4>{{ $t('workDetail') }}</h4>
              <hr />
              <p class="text">
                <template v-if="form['work' + id + '_trapdoor'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('trapdoor') }}
              </p>
              <p class="text" v-if="form['work' + id + '_trapdoor'] == 1">
                {{ $t('numberTrapdoor') }}
                <span>{{ form['work' + id + '_numberTrapdoor'] }}</span>
              </p>
              <p class="text" v-if="form['work' + id + '_trapdoor'] == 1">
                {{ $t('stateOfTrapdoor') }}
                <span>{{ getValueOf(form['work' + id + '_stateOfTrapdoor']) }}</span>
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_stick'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('stick') }}
              </p>
              <p class="text" v-if="form['work' + id + '_stick'] == 1">
                {{ $t('stateOfStick') }}
                <span>{{ getValueOf(form['work' + id + '_stateOfStick']) }}</span>
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_scaleToApron'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('scaleToApron') }}
              </p>
              <p class="text" v-if="form['work' + id + '_scaleToApron'] == 1">
                {{ $t('stateOfScaleToApron') }}
                <span>{{ getValueOf(form['work' + id + '_stateOfScaleToApron']) }}</span>
              </p>

              <p class="text" v-if="form['work' + id + '_scaleToApron'] == 1">
                {{ $t('totalVolume') }}
                <span>{{ form['work' + id + '_totalVolume'] }}</span>
              </p>

              <p class="text">
                <template v-if="form['work' + id + '_overflow'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('overflow') }}
              </p>
              <p class="text" v-if="form['work' + id + '_overflow'] == 1">
                {{ $t('overflowHeight') }}
                <span>{{ form['work' + id + '_overflowHeight'] }}</span>
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_continuousWater'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('continuousWater') }}
              </p>
              <p class="text" v-if="form['work' + id + '_continuousWater'] == 1">
                {{ $t('continuousWaterHeight') }}
                <span>{{ form['work' + id + '_continuousWaterHeight'] }}</span>
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_warehouse'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('warehouse') }}
              </p>
              <p class="text" v-if="form['work' + id + '_warehouse'] == 1">
                {{ $t('warehouseHight') }}
                <span>{{ form['work' + id + '_warehouseHight'] }}</span>
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_presenceWasteWater'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('presenceWasteWater') }}
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_presenceHydrocarbon'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('presenceHydrocarbon') }}
              </p>
              <p class="text">
                <template v-if="form['work' + id + '_performedDescent'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('performedDescent') }}
              </p>
              <p class="text">
                {{ $t('numberArrival') }}
                <span>{{ form['work' + id + '_numberArrival'] }}</span>
              </p>
              <p class="text">
                {{ $t('observation') }}
                <span>{{ form['work' + id + '_observation'] }}</span>
              </p>
              <p class="text">
                {{ $t('controlOfWork') }}
                <span>{{ getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) }}</span>
              </p>
              <p
                class="text"
                v-if="
                  ![controlOfWorkInfiltration(), controlOfWorkCrapaudines()].includes(
                    getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork'))
                  )
                "
              >
                {{ $t('regulationModel') }}
                <span>{{ form['work' + id + '_regulationModel'] }}</span>
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) == controlOfWorkPompes()
                "
              >
                {{ $t('regulationLocation') }}
                <span>{{ getValueOf(form['work' + id + '_regulationLocation']) }}</span>
              </p>
              <p
                class="text"
                v-if="
                  [controlOfWorkCrapaudines(), controlOfWorkPompes()].includes(
                    getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork'))
                  )
                "
              >
                {{ $t('regulationNumber') }}
                <span>{{ form['work' + id + '_regulationNumber'] }}</span>
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) == controlOfWorkPompes()
                "
              >
                {{ $t('regulationDischargeHeight') }}
                <span>{{ form['work' + id + '_regulationDischargeHeight'] }}</span>
              </p>
              <p
                class="text"
                v-if="
                  [controlOfWorkVortex(), controlOfWorkSiphon(), controlOfWorkFlotteur()].includes(
                    getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork'))
                  )
                "
              >
                <template v-if="form['work' + id + '_regulationRope'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('regulationRope') }}
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) == controlOfWorkOrifice()
                "
              >
                {{ $t('regulationDiameter') }}
                <span>{{ form['work' + id + '_regulationDiameter'] }}</span>
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) == controlOfWorkOrifice()
                "
              >
                <template v-if="form['work' + id + '_regulationSluiceGate'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('regulationSluiceGate') }}
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) == controlOfWorkOrifice()
                "
              >
                <template v-if="form['work' + id + '_regulationOverflow'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('regulationOverflow') }}
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) ==
                  controlOfWorkCrapaudines()
                "
              >
                {{ $t('regulationHeight') }}
                <span>{{ form['work' + id + '_regulationHeight'] }}</span>
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) ==
                  controlOfWorkCrapaudines()
                "
              >
                <template v-if="form['work' + id + '_regulationEvacuationEquip'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('regulationEvacuationEquip') }}
              </p>
              <p
                class="text"
                v-if="
                  getControlOfWork(getFrozenControlPropertyWorkAttribute(id, 'controlOfWork')) !=
                  controlOfWorkInfiltration()
                "
              >
                <template v-if="form['work' + id + '_regulationOperation'] == 1">
                  <v-icon name="check" />
                </template>
                <template v-else>
                  <v-icon name="times" class="nok" />
                </template>
                {{ $t('regulationOperation') }}
              </p>
              <p class="text">
                {{ $t('evacuationMaintenanceRetention') }}
                <span>{{ getValueOf(form['work' + id + '_evacuationMaintenanceRetention']) }}</span>
              </p>
              <p class="text">
                {{ $t('evacuationMaintenanceControl') }}
                <span>{{ getMaintenaceControl(form['work' + id + '_evacuationMaintenanceControl']) }}</span>
              </p>
              <p class="text">
                {{ $t('observationRegulation') }}
                <span>{{ form['work' + id + '_observationRegulation'] }}</span>
              </p>
            </span>
          </Content>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_VPT, TYPE_VE } from '../../constants/params';
import { mapState } from 'vuex';
import Content from '../Content';
import {
  CONTROL_OF_WORK_POMPES,
  CONTROL_OF_WORK_VORTEX,
  CONTROL_OF_WORK_SIPHON,
  CONTROL_OF_WORK_FLOTTEUR,
  CONTROL_OF_WORK_ORIFICE,
  CONTROL_OF_WORK_CRAPAUDINES,
  CONTROL_OF_WORK_INFILTRATION
} from '../../constants/params';

export default {
  Name: 'WorksDetail',
  props: {
    form: { required: true },
    typeForm: { type: String, required: true },
  },
  components: {
    Content,
  },
  computed: {
    ...mapState({
      property: (state) => state.refProperties.property,
      workflows: (state) => state.workflow.workflows,
    }),
  },
  methods: {
    typeVpt: function () {
      return TYPE_VPT;
    },
    typeVe: function () {
      return TYPE_VE;
    },
    getValueOf(value) {
      const options = {
        before: 'Avant',
        after: 'Après',
        oui: 'Oui',
        non: 'Non',
        impossible: 'Indéterminé',
        good: 'Bon état',
        average: 'Etat moyen',
        bad: 'Mauvais état',
        difficult: 'Trappe lourde',
        'put-on-apron': 'Posée(s) sur le radier',
        'put-in-pit': 'Posée(s) dans une fosse',
        clean: 'Ouvrage propre',
        'dirty-debri': 'Ouvrage encrassé - débris',
        'dirty-floating': 'Ouvrage encrassé - flottants',
        blocked: 'Ouvrage saturé',
        'notebook-not-presented': 'Non présenté',
        'notebook-presented': 'Présenté',
        'notebook-to-send': 'A renvoyer',
        'non-presented': 'Non présenté',
        presented: 'Présenté',
        'send-back': 'A renvoyer',
      };
      return options[value];
    },
    getMaintenaceControl: function (value) {
      const options = {
        clean: 'Régulateur propre',
        'dirty-debri': 'Régulateur encrassé - débris',
        'dirty-floating': 'Régulateur encrassé - flottants',
        blocked: 'Régulateur bouché',
      };
      return options[value];
    },
    controlOfWorkPompes: function () {
      return CONTROL_OF_WORK_POMPES;
    },
    controlOfWorkVortex: function () {
      return CONTROL_OF_WORK_VORTEX;
    },
    controlOfWorkSiphon: function () {
      return CONTROL_OF_WORK_SIPHON;
    },
    controlOfWorkFlotteur: function () {
      return CONTROL_OF_WORK_FLOTTEUR;
    },
    controlOfWorkOrifice: function () {
      return CONTROL_OF_WORK_ORIFICE;
    },
    controlOfWorkCrapaudines: function () {
      return CONTROL_OF_WORK_CRAPAUDINES;
    },
    controlOfWorkInfiltration: function () {
      return CONTROL_OF_WORK_INFILTRATION;
    },
    getControlOfWork(value) {
      const options = [
        'Pompes',
        'Vortex',
        'Effet siphon',
        'A flotteur',
        'Orifice / Plaque',
        'Crapaudines',
        'Infiltration',
      ];
      return options[value];
    },
    getTypeOfWork(value) {
      const options = [
        'Bassin enterré avec casiers',
        "Bassin enterré en nid d'abeille",
        'Bassin enterré visitable',
        'Bassin ouvert en eau',
        'Bassin ouvert sec',
        'Canalisation surdimensionnée',
        'Cuve de réutilisation des eaux de pluies',
        'Noue Minérale',
        'Noue Végétalisée',
        "Puits d'infiltration non visitable",
        "Puits d'infiltration vide",
        "Puits d'infiltration visitable",
        'Toiture terasse minérale',
        'Toiture végétalisée extensive',
        'Toiture végétalisée intensive',
        'Toiture végétalisée semi-intensive',
        'Tranchée Drainante',
      ];
      return options[value];
    },
    hasValidatedStatus() {
      if (this.workflows) {
        for (let index = 0; index < this.workflows.length; index++) {
          const workflow = this.workflows[index];
          if (workflow.status.id == 'validated') {
            return true;
          }
        }
      }

      return false;
    },
    getFrozenControlPropertyWorkAttribute(workId, attribute) {
      if (this.hasValidatedStatus()) {
        return this.form[`work${workId}_${attribute}`];
      }

      return this.property.conception.works[workId - 1][attribute];
    },
    isEnabledWork(workId) {
      if (this.hasValidatedStatus()) {
        return (
          this.form[`work${workId}_typeOfWork`] ||
          this.form[`work${workId}_regulation`] ||
          this.form[`work${workId}_number`]
        );
      }

      return true;
    },
    worksCount() {
      let workCount = 0;

      if (this.hasValidatedStatus()) {
        for (let index = 1; index <= 5; index++) {
          if (
              this.form[`work${index}_typeOfWork`] ||
              this.form[`work${index}_regulation`] ||
              this.form[`work${index}_number`]
          ) {
            workCount = index;
          }
        }

        return workCount;
      }

      return this.property.conception.works.length;
    },
  },
};
</script>
